import { render, staticRenderFns } from "./Expirado.vue?vue&type=template&id=58eb5631&scoped=true"
import script from "./Expirado.vue?vue&type=script&lang=js"
export * from "./Expirado.vue?vue&type=script&lang=js"
import style0 from "./Expirado.vue?vue&type=style&index=0&id=58eb5631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb5631",
  null
  
)

export default component.exports